export default "__VITE_ASSET__D0J3FmyK__"